import React from 'react'
import PropTypes from 'prop-types'
import ArrowUp from 'images/arrow-up-green.svg'

const ArrowUpGreen = ({
  value,
  fontSize = 14,
  lineHeight = 17
}) => (
  <div className='flex justify-content-center '>
    <img src={ArrowUp} />
    {value && <span style={{fontSize, lineHeight: `${lineHeight}px`}} className='margin-left-extra-small green-text' > +{value}% </span>}
  </div>
)

ArrowUpGreen.propTypes = {
  value: PropTypes.string,
  fontSize: PropTypes.number,
  lineHeight: PropTypes.number
}

export default ArrowUpGreen
